import React, { useRef } from 'react';
import FormModal from './FormModal';
import Table from 'cccisd-graphql-table';
import Actions from './Actions';
import ExistingContacts from './DropdownModal';
import contactsQuery from './contacts.graphql';
import orgLearnerContactsQuery from './orgLearnerContacts.graphql';
import style from './style.css';

const isOrgProvider = window.cccisd.fortress.user.acting.role.handle === 'orgInstructor';

const StudentContacts = ({
    value,
    row,
    plan,
    loadData,
    otherPlanContacts,
    options,
    session,
    closeStudentContactsModal,
    contactTypes,
    notifications,
}) => {
    const pawnId = row['pawn.pawnId'];
    const contacts = row['childRoles.contactList'];
    const assignmentPlanId = plan.assignmentPlanId;
    const table = useRef();

    const reloadTable = () => {
        table.current.loadData();
    };

    const columns = [
        {
            name: 'fields.contactName',
            label: 'Name',
        },
        {
            name: 'fields.contactEmail',
            label: 'Email',
        },
        {
            name: 'fields.contactType',
            label: 'Contact Type',
        },
        {
            name: 'pawn.pawnId',
            label: 'Actions',
            render: props => {
                return (
                    <Actions
                        {...props}
                        reloadTable={reloadTable}
                        loadData={loadData}
                        options={options}
                        session={{ ...session, assignmentPlanId: plan.assignmentPlanId }}
                    />
                );
            },
        },
    ];

    return (
        <div>
            {notifications?.length > 0 && (
                <div className="alert alert-warning" role="alert">
                    <strong>Missing contacts: </strong>
                    {notifications.join(', ')}
                </div>
            )}
            <div className={style.formButtonContainer}>
                {otherPlanContacts.length > 1 && (
                    <ExistingContacts
                        value={value}
                        contacts={contacts}
                        reloadTable={reloadTable}
                        assignmentPlanId={assignmentPlanId}
                        options={otherPlanContacts}
                        loadData={loadData}
                        session={{ ...session, assignmentPlanId }}
                        closeStudentContactsModal={closeStudentContactsModal}
                        contactTypes={contactTypes}
                    />
                )}
                <FormModal
                    value={value}
                    row={row}
                    reloadTable={reloadTable}
                    assignmentPlanId={assignmentPlanId}
                    loadData={loadData}
                    otherPlanContacts={otherPlanContacts}
                    options={options}
                    session={{ ...session, assignmentPlanId }}
                    closeStudentContactsModal={closeStudentContactsModal}
                />
            </div>
            <Table
                rowKey="pawn.pawnId"
                ref={table}
                query={isOrgProvider ? orgLearnerContactsQuery : contactsQuery}
                columns={columns}
                graphqlVariables={{ pawnId, assignmentPlanId }}
            />
        </div>
    );
};

export default StudentContacts;
